import { Box } from '@mantine/core';

import { useGetColor } from 'hooks';

import type { IconPropsType } from './types';

export const ZoomInIcon = ({
  color,
  size = 24,
  sx,
  ...props
}: IconPropsType) => {
  const iconColor = useGetColor(color);

  return (
    <Box
      component="svg"
      sx={sx}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        stroke={iconColor}
        strokeLinecap="round"
        strokeWidth={1.5}
        d="m20 20-4.571-4.571M10.857 8v5.714M8 10.857h5.714m-2.857 6.857a6.857 6.857 0 1 1 0-13.714 6.857 6.857 0 0 1 0 13.714Z"
      />
    </Box>
  );
};
